export default {
  'Welcome to the materialflows quiz': 'Willkommen zum Materialfluss-Quiz',
  'Start quiz': 'Quiz starten',
  'Please choose at least one topic.': 'Bitte wählen Sie mindestens ein Thema aus',
  'Language': 'Sprache',
  'German': 'Deutsch',
  'English': 'Englisch',
  'Mode': 'Modus',
  'Presentation mode': 'Präsentationsmodus',
  'Topics': 'Themen',
  'Configuration': 'Konfiguration',
  'Question': 'Frage',
  'of': 'von',
  'Final result': 'Zur Auswertung',
  'Skip question': 'Frage überspringen',
  'More info': 'Mehr Info',
  'Continue': 'Weiter',
  'Congratulations': 'Herzlichen Glückwunsch',
  'You have correctly answered <span class=\'text-primary\'>{0} of {1}</span> questions!': 'Sie haben <span class=\'text-primary\'>{0} von {1}</span> Fragen korrekt beantwortet!',
  'for a better understanding of the world of raw materials!': 'für ein besseres Verständnis der Welt der Rohstoffe!',
  'Restart quiz': 'Quiz neu starten',
  'Visit materialflows.net': 'Zu materialflows.net',
  'Result': 'Resultat'
}



// WEBPACK FOOTER //
// ./src/locale/de.js